import { render, staticRenderFns } from "./LomDetails.vue?vue&type=template&id=432da48a"
import script from "./LomDetails.vue?vue&type=script&lang=js"
export * from "./LomDetails.vue?vue&type=script&lang=js"
import style0 from "./LomDetails.vue?vue&type=style&index=0&id=432da48a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports